<template>
  <layout>
    <div slot="content">
      <i-card title="直播列表">
        <div slot="content">
          <el-table
            v-loading="loading"
            :border="true"
            :highlight-current-row="true"
            :data="shipList"
            style="width: 100%">
            <el-table-column
              prop="cover_img"
              label="封面图片"
              width="80"
            >
             <template slot-scope="scope">
               <img :src="scope.row.cover_img" width="50" height="50">
            </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="直播名称"
            >
            </el-table-column>


            <el-table-column
              prop="start_time"
              label="开播时间"
              width="160"
            >
            </el-table-column>
            <el-table-column
              label="直播状态"
              width="80"
            >
              <template slot-scope="scope">
           <el-tag size="mini" type="success" v-if="scope.row.live_status === 101">直播中</el-tag>
                         <el-tag size="mini" type="success" v-if="scope.row.live_status === 102">未开始</el-tag>
           <el-tag size="mini" type="success" v-if="scope.row.live_status === 103">已结束</el-tag>
           <el-tag size="mini" type="success" v-if="scope.row.live_status === 104">禁播</el-tag>
           <el-tag size="mini" type="success" v-if="scope.row.live_status === 105">暂停</el-tag>
           <el-tag size="mini" type="success" v-if="scope.row.live_status === 106">异常</el-tag>
           <el-tag size="mini" type="success" v-if="scope.row.live_status === 107">已过期</el-tag>
              </template>
            </el-table-column>


            <el-table-column
              prop="share_img"
              label="推荐产品"
              width="200"
            >
 <template slot-scope="scope">
              <img :src="list.cover_img" width="50" height="50" v-for="(list,i) in scope.row.goods" :key="i" style="margin-left: 5px;" v-if="i < 3">
           </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="虚拟人数"
              width="80"
            >
            <template slot-scope="scope">
            <el-tag size="small"
                    style="margin-right: 10px;">{{scope.row.num}}
            </el-tag>
               </template>
            </el-table-column>
            <el-table-column
              prop="str"
              label="文字"
              width="70"
            >

            </el-table-column>
            <el-table-column
              label="操作"
              width="200"
            >
              <div style="text-align: center" slot-scope="scope">
                <el-button size="mini" type="primary" @click="addLabel(scope.row.roomid)" >
                  修改人数
                </el-button>
 <el-button size="mini" type="primary" @click="addLabel_(scope.row.roomid)" >
                  修改文字
                </el-button>
              </div>
            </el-table-column>
          </el-table>
          <div style="padding: 10px;text-align: center" v-if="totalpage > 1">
           <el-button size="mini" type="primary" @click="gotopage(1)" :disabled="pre_use">
             上一页
           </el-button>
 <el-button size="mini" type="primary" @click="gotopage(2)" :disabled="next_use">
             下一页
           </el-button>
          </div>
        </div>

      </i-card>
      <i-fx :show="showFxStatus" :product-id="currProductId" @change="showFx"></i-fx>
      <i-extension :show="showExtensionStatus" :product-id="currProductId" :goods-title="currGoodsTitle" @change="showExtension"></i-extension>
      <el-dialog
        title="直播间名称"
        :visible.sync="bindSailingsDialog"
        :append-to-body="true"
        width="50%"
      >
        <el-table
          ref="sailingsTable"
          :data="sailingsList"
          tooltip-effect="dark"
          @selection-change="getInfo"
          style="width: 100%"
        >
    <el-table-column
            type="selection"
            width="55">
          </el-table-column>

          <el-table-column
            prop="name"
            label="直播间名称"
          >
          </el-table-column>
          <el-table-column
            prop="start_time"
            label="开播时间"
          >

          </el-table-column>

          <el-table-column
            label="直播状态"
            width="80"
          >
            <template slot-scope="scope">
              <el-tag size="mini" type="success" v-if="scope.row.live_status === 101">直播中</el-tag>
              <el-tag size="mini" type="success" v-if="scope.row.live_status === 102">未开始</el-tag>
              <el-tag size="mini" type="success" v-if="scope.row.live_status === 103">已结束</el-tag>
              <el-tag size="mini" type="success" v-if="scope.row.live_status === 104">禁播</el-tag>
              <el-tag size="mini" type="success" v-if="scope.row.live_status === 105">暂停</el-tag>
              <el-tag size="mini" type="success" v-if="scope.row.live_status === 106">异常</el-tag>
              <el-tag size="mini" type="success" v-if="scope.row.live_status === 107">已过期</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="share_img"
            label="推荐产品"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="虚拟人数"
          >
          </el-table-column>
          <el-table-column
            prop="str"
            label="文字"
          >

          </el-table-column>

        </el-table>

        <div slot="footer" class="dialog-footer">
          <el-button @click="bindSailingsDialog = false">取 消</el-button>
          <el-button type="primary" :loading="bindSailingsLoading" @click="postBind">确
            定
          </el-button>
        </div>
      </el-dialog>
    </div>
  </layout>
</template>

<script>
  import iFx from "@/components/i-fenxiao"
  import iExtension from "@/components/i-extension"

  export default {
    name: "ship",
    components: {iFx, iExtension},
    data() {
      return {
        shipList: [],
        loading: false,
        dialogVisible: false,
        distributionInfo: ['', ''],
        currUnicode: '',
        currProductId: '',
        currGoodsTitle: '',
        showFxStatus: false,
        distributionLoading: false,
        bindSailingsDialog: false,
        bindSailingsLoading: false,
        selectedSailings: "",
        sailingsList: [],
        page:0,
        totalpage:0,
        pre_use:false,
        next_use:false,
        currShipId: "",
        showExtensionStatus: false,
      }
    },
    methods: {
      setDistribution: function (productId) {
        this.showFxStatus = true;
        this.currProductId = productId;
      },
      gotopage(v){
        this.getShipList(v);
      },
      addLabel: function (rid) {
        this.$prompt('请输入人数', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({value}) => {
          this.getShipList1(1,value,rid);
          /*const secounds = 5
          	let num = 0
          	const timer = setInterval(() => {
          		if(num < secounds) {
          			num++
          		}else {
          			clearInterval(timer)
          			 location.reload();
          		}
          	}, 1000)// 这里的时间不要忘记，否则没有效果*/
        })
      },
      addLabel_: function (rid) {
        this.$prompt('请输入文字', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({value}) => {
          this.getShipList1(2,value,rid);
          /*const secounds = 5
          	let num = 0
          	const timer = setInterval(() => {
          		if(num < secounds) {
          			num++
          		}else {
          			clearInterval(timer)
          			 location.reload();
          		}
          	}, 1000)// 这里的时间不要忘记，否则没有效果*/
        })
      },
      showFx: function (show) {
        this.showFxStatus = show;
      },
      setExtension: function (productId,title) {
        this.showExtensionStatus = true;
        this.currProductId = productId;
        this.currGoodsTitle  = title;
      },
      showExtension:function (show) {
        this.showExtensionStatus = show;
      },
      getShipList: function (t) {
        if(t==1)
         this.page=this.page-2;
        let _self = this;
        this.loading = true;
        this.$http.request('liveList',{type:this.page}).then((res) => {
          this.page=this.page+1;
          this.totalpage=res.totalpage;
              if(res.totalpage == 1 && this.page==1){
                              this.pre_use=true;
                              this.next_use=true;
              }else if(res.totalpage > 1 && this.page==1){
                              this.pre_use=true;
                              this.next_use=false;
              }else if(res.totalpage > 1 && this.page > 1 && this.page == (res.totalpage-1)){
                              this.pre_use=false;
                              this.next_use=true;
              }else if(res.totalpage > 1 && (res.totalpage-1) != this.page){
                             this.pre_use=false;
                             this.next_use=false;
              }
          _self.shipList = res.room_info;
          _self.loading = false;
        });
      },
      getShipList1: function (type,value,rid) {
        this.$http.request('saveLive',{type:type,value:value,rid:rid}).then((res) => {
          if(res==1)
            this.$message({
              message: '修改成功',
              type: 'success'
            });
            else
            this.$message({
              message: '修改失败',
              type: 'warning'
            });
        });
      },
      getSailingsList: function (shipId) {
        this.bindSailingsDialog = true;
        this.sailingsList = [];
        this.currShipId = shipId;
        this.$http.request('bindSingsList', {ship_id: shipId}).then((res) => {
          this.sailingsList = res.data.sailings;
          this.sailingsList.forEach((row) => {
            res.data.binds.forEach((bindRow) => {
              if (bindRow.id === row.id) {
                this.$nextTick(() => {
                  this.$refs.sailingsTable.toggleRowSelection(row)
                });
              }
            });

          })
        });
      },
      getInfo(val) {
        this.selectedSailings = "";
        val.forEach((row) => {
          this.selectedSailings += row.id + ",";
        });
      },
      postBind: function () {
        this.bindSailingsLoading = true;
        this.$http.request('doBindSailings', {
          ship_id: this.currShipId,
          sailingIds: this.selectedSailings
        }).then((res) => {
          this.bindSailingsLoading = false;
          this.bindSailingsDialog = false;
          this.$message({
            message: res.message,
            type: 'success'
          });
        });
      },
      delProduct:function (id) {
        this.$confirm('是否删除该商品？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.request('delProduct', {product_id: id}).then((res) => {
            let _self = this;
            if (res.status === 'success') {
              this.$message({
                type: 'success',
                message: res.message,
                onClose: function () {
                  _self.getShipList();
                }
              });
            }
          });
        })
      }
    },
    created: function () {
      this.getShipList();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/product/live.vue